// Swiss amount formatting — ASCII apostrophe thousands separator, no decimals.
//
// We don't rely on toLocaleString('de-CH'): modern CLDR returns the typographic
// right single quotation mark (U+2019) instead of the ASCII apostrophe (U+0027),
// which is what the brief and existing UI conventions specify.

export const EM_DASH = '—';

export function formatSwissAmount(value) {
  if (value === null || value === undefined || value === '') return EM_DASH;
  const n = Number(value);
  if (!Number.isFinite(n)) return EM_DASH;
  const rounded = Math.round(n);
  if (rounded === 0) return EM_DASH;
  const sign = rounded < 0 ? '-' : '';
  const abs = Math.abs(rounded).toString();
  return sign + abs.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
}

// Unit-aware formatting for the sales views (CHF vs kCHF toggle).
// In kCHF, values are divided by 1000 (rounded). Unit label via amountUnitLabel.
export function formatSwissAmountUnit(value, unit = 'CHF') {
  if (unit === 'KCHF') {
    const n = Number(value);
    if (!Number.isFinite(n)) return EM_DASH;
    return formatSwissAmount(n / 1000);
  }
  return formatSwissAmount(value);
}

export function amountUnitLabel(unit = 'CHF') {
  return unit === 'KCHF' ? 'kCHF' : 'CHF';
}

export function parseSwissAmount(input) {
  if (typeof input === 'number') return Number.isFinite(input) ? input : 0;
  if (input === null || input === undefined || input === '') return 0;
  const str = String(input);
  const cleaned = str
    .replace(/[\s ’']/g, '')
    .replace(',', '.');
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}
